import { ProfileClassificationCode } from "../api/holdings/types";

export const isProfessionalClassification = (classificationCode?: string): boolean => {
    return classificationCode === ProfileClassificationCode.PROF || classificationCode === ProfileClassificationCode.CP;
};